import React from 'react'
import { IoWarning } from 'react-icons/io5'
import { Loader } from '../../hook'

const DeleteModel = ({ loader, unSetLoader, DeleteCategory }) => {
    return (
        <div className="fixed inset-0 bg-[black]/30 z-[999] overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4">
                <div className="bg-white overflow-hidden rounded-6 p-5 lg:p-7 max-w-[500px] w-full min-w-[350px]">
                    <div className="flex items-center justify-center mb-5">
                        <IoWarning className="p-3 bg-red/20 rounded-full text-red/90 text-42 w-20 h-20" />
                    </div>
                    <h1 className="font-medium mb-5 text-center text-base lg:text-27 text-black">
                        Are you sure?
                    </h1>

                    <div className="flex justify-end gap-4 items-center mt-7">
                        <button
                            onClick={() => unSetLoader()}
                            className="border border-red/80 text-red/80 font-medium rounded-6 py-1.5 px-2.5 w-full text-base"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => DeleteCategory()}
                            className="bg-red/90 text-white font-medium rounded-6 py-1.5 px-2.5 w-full text-base"
                        >
                            {loader ? <Loader /> : "Delete"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteModel